import { defineStore } from "pinia";
import { ref } from "vue";
import { i18n, persistLocale, type LocaleCode, detectLocale } from "@/plugins/i18n";
import { applyTheme, detectTheme, type ThemeMode } from "@/plugins/primevue";

export const useUIStore = defineStore("ui", () => {
  const locale = ref<LocaleCode>(detectLocale());
  const theme = ref<ThemeMode>(detectTheme());

  function setLocale(loc: LocaleCode) {
    locale.value = loc;
    i18n.global.locale.value = loc;
    persistLocale(loc);
    document.documentElement.lang = loc;
  }

  function toggleTheme() {
    theme.value = theme.value === "dark" ? "light" : "dark";
    applyTheme(theme.value);
  }

  return { locale, theme, setLocale, toggleTheme };
});
